export const LOCAL_BACKEND_BASE_URL = 'http://transc-farga-eusaog73iyra-1099781763.us-east-1.elb.amazonaws.com';

export const PROD_BACKEND_BASE_URL = 'https://api.admin.museum.eko.com';

export const OPEN_AI_BASE_URL = 'https://api.openai.com/v1/threads';

export const OPEN_AI_SECRET_KEY =
  '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 ';

export const OPEN_AI_ASSISTANT_ID = 'asst_plWVj4kPxV3C8pJavc6bfMH5';
